import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Shield, TrendingUp, Clock } from 'lucide-react';
import { servicesData } from '../data/mockData';

const PrimaryTradelinesPage = () => {
  // Filter only primary tradelines (including mortgage tradelines).
  // $50,000 primary auto tradeline is now included (re-enabled per product decision).
  const primaryTradelines = servicesData.filter(service =>
    service.title.includes('Primary') &&
    service.title.includes('Tradeline') &&
    service.title.includes('$') &&
    !service.title.includes('$100,000')
  );

  return (
    <div className="dark-page tradelines-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">PRIMARY TRADELINES</div>
          <h1 className="display-large tradelines-title">
            Build Credit in <span className="text-gradient">YOUR Name</span>
          </h1>
          <p className="body-large tradelines-subtitle">
            Primary tradelines are accounts where YOU are the account holder - not an authorized user. 
            These carry significantly more weight with lenders and build real, independent credit history.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <Shield size={24} />
              <span>Primary Account Holder</span>
            </div>
            <div className="tradeline-feature-item">
              <TrendingUp size={24} />
              <span>Revolving & Installment Available</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>Reports in 14-45 Days</span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Banner */}
      <section className="guarantee-banner">
        <div className="guarantee-content">
          <CheckCircle2 size={32} />
          <p>All tradelines guaranteed to post within 2 billing cycles or your money back</p>
        </div>
      </section>

      {/* Tradelines Grid */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Choose Your Tradeline</h2>
          <p className="body-medium section-description">
            Select the credit limit that fits your goals. We'll place the best account type for your credit profile.
          </p>
        </div>

        <div className="tradelines-grid">
          {primaryTradelines.map((tradeline) => (
            <div key={tradeline.id} className="tradeline-card" data-testid="primary-tradeline-card">
              <div className="tradeline-card-header">
                <h3 className="tradeline-card-title">{tradeline.title}</h3>
              </div>
              
              <p className="tradeline-card-description">{tradeline.description}</p>
              
              <ul className="tradeline-card-features">
                {tradeline.features.slice(0, 6).map((feature, idx) => (
                  <li key={idx} className="tradeline-feature">
                    <CheckCircle2 size={16} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="tradeline-card-footer">
                <a
                  href="https://calendly.com/thecollinsacademynew/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary tradeline-buy-btn"
                  data-testid="sign-up-btn"
                >
                  Sign Up
                  <ArrowRight size={18} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Not Sure Which Tradeline You Need?</h2>
          <p className="body-large">Book a strategy call and we'll analyze your credit profile to recommend the perfect tradeline package.</p>
          <a 
            href="https://calendly.com/thecollinsacademynew/30min" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary"
          >
            Schedule Consultation
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default PrimaryTradelinesPage;
